$(".smooth-scroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
        // Prevent default anchor click behavior
        event.preventDefault();

        // Store hash
        var hash = this.hash;

        // Using jQuery's animate() method to add smooth page scroll
        // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 800, function(){

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
        });
    } // End if
});

let $navbarBurger = $('.layout-nav-bar__navbar-burger')
let $navbar = $('.components-layout-navigation__navbar');
let $navigation = $('.components-layout-navigation');
let $homeArrowDown = $('.components-homepage-header__arrow-container');
let $layoutScrollUp = $('.layout-scroll-up');
let $layoutAlwaysButton = $('.components-layout-always-visible-button--visibility');
let $layoutNabBar = $('.layout-nav-bar');
let navHeight = $layoutNabBar.height() +
    parseInt($layoutNabBar.css('border-top-width')) +
    parseInt($layoutNabBar.css('border-bottom-width')) - 1;

$navbarBurger.click(function (e) {
    e.preventDefault();
    if ($navbarBurger.hasClass('is-active')) {
        $navigation.removeClass('is-active');
        $('.layout-nav-bar__mobile-toggle').removeClass('is-active');
        toggleNavigationTransparency();
    } else {
        $navigation.addClass('is-active');
        if ($navbar.hasClass('is-transparentable')) {
            $navbar.removeClass('is-transparent');
        }
        $('.layout-nav-bar__mobile-toggle').addClass('is-active');
    }
});

$('.web-pages_home__slideshow').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    draggable: false,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    speed: 500,
    infinite: true,
    dots: true,
    pauseOnDotsHover: true,
    cssEase: 'ease-in',
    appendDots: '.web-pages_home__dots',
    customPaging: function(slider, i) {
        return '<a><span class="icon icon--active"><i class="fas fa-circle"></i></span><span class="icon icon--non-active"><i class="far fa-circle"></i></span></a>';
    }
});

function toggleScrollUp()
{
    let top = parseInt($(this).scrollTop());

    if (top > 0) {
        $layoutNabBar.addClass('is-hovering');
    } else {
        top = 0;
        $layoutNabBar.removeClass('is-hovering');
    }

    if (top >= navHeight+50) {
        $layoutScrollUp.fadeIn(200);
        $homeArrowDown.fadeOut(200);
        if ($layoutAlwaysButton.length) {
            $layoutAlwaysButton.fadeIn(200);
        }
    } else {
        $layoutScrollUp.fadeOut(200);
        $homeArrowDown.fadeIn(200);
        if ($layoutAlwaysButton.length) {
            $layoutAlwaysButton.fadeOut(200);
        }
    }
}

function fadeHp()
{
    let $background = $('.layouts-default__background');
    let $shadow = $('.layouts-default__shadow');
    if ($shadow.length || $background.length) {
        let position = parseInt(window.pageYOffset);
        let visibleHeight = parseInt(window.innerHeight);
        let documentHeight = $(document).height() - visibleHeight;

        let start = 1;
        let max = 0.9;

        let maximum = documentHeight < (visibleHeight * start) ? documentHeight : (visibleHeight * start);

        let opacity = start - (position / maximum);

        if (opacity < 0) {
            opacity = 0;
        }

        if (documentHeight < (visibleHeight * 0.33)) {
            opacity = max;
        }

        if (opacity > max) {
            opacity = max;
        }

        if ($shadow.length) {
            $shadow.css('background-color', 'rgba(240, 240, 240, ' + opacity + ')');
        }
        if ($background.length) {
            $background.css('opacity', 1 - opacity);
        }
    }
}

function toggleNavigationTransparency()
{
    if ($navbar.hasClass('is-transparentable') && !$navbarBurger.hasClass('is-active')) {
        if (parseInt(window.pageYOffset) <= 8) {
            $navbar.addClass('is-transparent');
        } else {
            $navbar.removeClass('is-transparent');
        }
    }
}

$(window).scroll(function() {
    toggleScrollUp();
    toggleNavigationTransparency();
    fadeHp();
});

$(window).on('load resize', function () {
    toggleScrollUp();
    toggleNavigationTransparency();
    fadeHp();
});

toggleScrollUp();
toggleNavigationTransparency();
fadeHp();
